import { Box, Button, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import { GeneralConstants } from 'app/constants/general-constants';
import { Mcc } from 'app/model/cris/mcc';
import { mccService } from 'app/services/tools/mcc.service';
import { MccListGrid } from 'features/cris/mccs/mcc-list-grid';

export const MccSearch: React.FunctionComponent = () => {
    const [query, setQuery] = useState('');
    const [categories, setCategories] = useState<Mcc[]>([]);

    const findCategories = () => {
        mccService
            .listAll({
                pageSize: GeneralConstants.PAGE_SIZE_HUGE,
                queryFilters: { search: query },
            })
            .subscribe(setCategories);
    };

    return (
        <>
            <Typography variant='body1' className='mb-1'>
                Search for MCCs within the system.
            </Typography>
            <form
                onSubmit={(evt) => {
                    evt.preventDefault();
                }}
            >
                <Box display='flex' mb={1}>
                    <Box flexGrow={1} mr={1}>
                        <TextField
                            name='term'
                            label='Search Term'
                            variant='outlined'
                            size='small'
                            value={query}
                            onChange={(evt) => setQuery(evt.target.value)}
                            fullWidth
                        />
                    </Box>
                    <Button variant='contained' color='primary' type='submit' onClick={findCategories}>
                        Search
                    </Button>

                    <Button
                        type='button'
                        variant='outlined'
                        color='warning'
                        className='ml-1'
                        component={RouterLink}
                        to='/cris/mccs/new'
                    >
                        Create MCC
                    </Button>
                </Box>
            </form>
            <MccListGrid
                rows={categories}
                paginationModel={{ pageSize: 50, page: 0 }}
                disableRowSelectionOnClick
                density='compact'
                pagination
            />
        </>
    );
};
